import { render } from "./ViewPanchanga.vue?vue&type=template&id=54ca7b28&scoped=true"
import script from "./ViewPanchanga.vue?vue&type=script&lang=js"
export * from "./ViewPanchanga.vue?vue&type=script&lang=js"

import "./ViewPanchanga.vue?vue&type=style&index=0&id=54ca7b28&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ca7b28"]])

export default __exports__